@if (dayMaxes) {
<table class="w-full text-center border-2 border-[--primary-white] mb-8">
  <thead class="bg-[--primary-white]">
    <tr>
      <th><p class="my-2">Dato</p></th>
      <th><p class="my-2">Time</p></th>
      <th><p class="my-2">kWh</p></th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let day of dayMaxes"
      class="py-2 border-b-2 border-[--primary-white]"
      [class.bold]="isHighThree(day.kwh)"
    >
      <td>
        <p class="my-2">
          {{ formatDate(day.period) }}
        </p>
      </td>
      <td>
        <p class="my-2">
          {{ formatTime(day.period) }}
        </p>
      </td>
      <td>
        <p class="my-2">
          {{ day.kwh.toFixed(2).replace('.', ',') }}
        </p>
      </td>
    </tr>
  </tbody>
</table>
}
